import {Button, Form, Modal} from "react-bootstrap";
import InputField from "../../components/InputField";
import {useEffect, useMemo, useRef, useState} from "react";
import useTranslation from "../../hooks/translations";
import {useApi} from "../../contexts/ApiProvider";
import CostTypeService from "../../services/CostTypeService";
import CheckboxField from "../../components/CheckboxField";

export default function CostTypeModal({
                                        showModal,
                                        title,
                                        data,
                                        onModalSubmit,
                                        onModalClose
                                      }) {
  const nameField = useRef();
  const descriptionField = useRef();
  const calculateForGrossField = useRef();
  const calculateForNet1Field = useRef();
  const calculateForNet2Field = useRef();

  const [formErrors, setFormErrors] = useState({});
  const translations = useTranslation();
  const api = useApi()
  const costTypeService = useMemo(() => new CostTypeService(api), [api]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      nameField.current.value = data.name;
      descriptionField.current.value = data.description;
      calculateForGrossField.current.checked = data.calculateForGross;
      calculateForNet1Field.current.checked = data.calculateForNet1;
      calculateForNet2Field.current.checked = data.calculateForNet2;
    } else {
      nameField.current.focus();
      calculateForGrossField.current.checked = false;
      calculateForNet1Field.current.checked = false;
      calculateForNet2Field.current.checked = false;
    }
  }, [data]);

  const handleClose = () => {
    onModalClose()
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const name = nameField.current.value;
    const description = descriptionField.current.value;
    const calculateForGross = calculateForGrossField.current.checked;
    const calculateForNet1 = calculateForNet1Field.current.checked;
    const calculateForNet2 = calculateForNet2Field.current.checked;

    const errors = {};
    if (!name) {
      errors.name = translations.errorName;
    }
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const submitData = {
      name,
      description,
      calculate_for_gross: calculateForGross,
      calculate_for_net_1: calculateForNet1,
      calculate_for_net_2: calculateForNet2
    }

    if (data.id) {
      const response = await costTypeService.put(data.id, submitData)
      if (!response.ok) {
        return
      }
    } else {
      const response = await costTypeService.create(submitData)
      if (!response.ok) {
        return
      }
    }

    onModalSubmit(submitData)
  }

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : translations.costType}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit} id="costTypeForm">
          <div className="mb-3">
            <InputField
              name="inputName"
              label={translations.name}
              placeholder={translations.enterName}
              error={formErrors.name}
              fieldRef={nameField}
            />
          </div>
          <div className="mb-3">
            <InputField
              name="inputDescription"
              label={translations.description}
              placeholder={translations.enterDescription}
              error={formErrors.description}
              fieldRef={descriptionField}
              asTextarea={true}
            />
          </div>
          <div className="mb-3">
            <CheckboxField
              name="inputCalculateForGross"
              label={translations.calculateForGross}
              fieldRef={calculateForGrossField}
            />
          </div>
          <div className="mb-3">
            <CheckboxField
              name="inputCalculateForNet1"
              label={translations.calculateForNet1}
              fieldRef={calculateForNet1Field}
            />
          </div>
          <div className="mb-3">
            <CheckboxField
              name="inputCalculateForNet2"
              label={translations.calculateForNet2}
              fieldRef={calculateForNet2Field}
            />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" type="submit"
                form="costTypeForm">{translations.save}</Button>
        <Button variant="secondary"
                onClick={handleClose}>{translations.close}</Button>
      </Modal.Footer>
    </Modal>
  )
}
